import React from 'react';
import { ProjectsList } from '../components/project/ProjectsList';

interface ProjectsPageProps {
  currentUserId?: string;
}

export const ProjectsPage: React.FC<ProjectsPageProps> = ({ currentUserId }) => {
  return <ProjectsList currentUserId={currentUserId} />;
};
